import { useQuery } from "react-query";
import { CommApiInstance } from "Utils/CommApiInstance";

import TrmsCtxtDataType from "Interface/Apis/TrmsCtxt.Interface";

const StarRateApi = async (
    gameSvcCd:string        ,
    qnaSno:number           ,
    starRtng:number         ,
    feedback:string|null
) => {
    return await CommApiInstance.post(`${"memb/qna/"+gameSvcCd + "/"+qnaSno+"/star_rtng/reg"}`,{
        apiBody:{
            starRtng:starRtng,
            feedback:feedback
        }
    })
    .then((Resp) => Resp.data); // apiBody가 아닌 data 전체 리턴
}


export default StarRateApi;